import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import UserActions from 'actions/UserActionCreators';

import PhoneField from 'components/v2/forms/PhoneField';
import Alert from 'components/ui/Alert';
import { Translation, withTranslation } from 'react-i18next';
import CargomaticInput from 'components/v2/input';
import FormCard from '../../v2/FormCard';
import Badge from '../../v2/Badge';
import CustomerSearch from '../../site/customer-search';
import UserActionCreators from '../../../actions/UserActionCreators';
import UserStore from '../../../stores/UserStore';
import SessionStore from '../../../stores/SessionStore';
import { SHIPPER_SUBSIDIARY_OPTIONS } from 'constants/subsidiary';

const getEmptyState = () => {
  return {
    shipper: {
      company_name: '',
      email: '',
      sales_rep: null,
      can_pay_manually: true,
      first_name: '',
      last_name: '',
      password: '',
      phone: '',
      master_account: {
        name: '',
        id: '',
      },
      subsidiary: '',
    },
    isCustomerManager: SessionStore.isCustomerManagerAdmin(),
    salespeople: [],
  };
};

class RegisterShipper extends Component {
  constructor(props) {
    super(props);
    this.state = getEmptyState();
  }

  componentDidMount() {
    UserStore.addChangeListener(this.handleUserStoreChange);
    UserActions.getSalespeople();
  }

  componentWillUnmount() {
    UserStore.removeChangeListener(this.handleUserStoreChange);
  }

  handleUserStoreChange = () => {
    const salespeople = UserStore.getSalesReps().map((rep) => {
      const first_name = (rep.first_name || '').trim();
      const last_name = (rep.last_name || '').trim();
      const name = `${first_name} ${last_name}`.trim();

      return {
        ...rep,
        first_name,
        last_name,
        name,
      };
    });
    console.log(salespeople);
    this.setState({ salespeople });
  };

  handlePhoneChange = (phone) => {
    this.setState((prevState) => {
      return {
        shipper: {
          ...prevState.shipper,
          phone,
        },
      };
    });
  };

  handleChange = (field) => (e) => {
    const {
      target: { value },
    } = e;
    this.setState((prevState) => {
      return {
        shipper: {
          ...prevState.shipper,
          [field]: value,
        },
      };
    });
  };

  handleSelect = (text, shipper) => {
    const { _id: id, name } = shipper;

    this.setState((prevState) => {
      return {
        shipper: {
          ...prevState.shipper,
          master_account: {
            id,
            name,
          },
        },
      };
    });
  };

  handleRegister = (e) => {
    e.preventDefault();
    const { shipper } = this.state;
    const master_account = shipper.master_account.id
      ? shipper.master_account
      : {};
    UserActionCreators.addCargomaticUser({
      ...shipper,
      master_account,
    });
    this.setState(getEmptyState());
  };

  handleClearMasterAccount = () => {
    this.setState((prevState) => {
      return {
        shipper: {
          ...prevState.shipper,
          master_account: { name: '', id: '' },
        },
      };
    });
  };

  render() {
    const { shipper, isCustomerManager } = this.state;
    const { t } = this.props;
    const disabled =
      isEmpty(shipper.company_name) ||
      isEmpty(shipper.sales_rep) ||
      isEmpty(shipper.email) ||
      isEmpty(shipper.first_name) ||
      isEmpty(shipper.last_name) ||
      isEmpty(shipper.password) ||
      isEmpty(shipper.phone);

    return (
      <FormCard
        actions={() => (
          <button
            disabled={disabled || !isCustomerManager}
            className="button button-green"
            type="submit"
            onClick={this.handleRegister}
          >
            {t('REGISTER_SHIPPER')}
          </button>
        )}
      >
        {!isCustomerManager && (
          <Alert type="warning">
            <Translation>
              {(t) => <p>{t('REQUIRED_CUSTOMER_MANAGER_PRIVILEGES')}</p>}
            </Translation>
          </Alert>
        )}
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900 leading-6">
            {t('SHIPPER_PROFILE')}
          </h3>
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('FIRST_NAME')}</label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder="John"
              onChange={this.handleChange('first_name')}
              value={shipper.first_name}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('LAST_NAME')}</label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder="Smith"
              onChange={this.handleChange('last_name')}
              value={shipper.last_name}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">
              <span>{t('SALES_REP')}</span>
            </label>
            <select
              className="mb-4 form-select"
              onChange={this.handleChange('sales_rep')}
              value={shipper.sales_rep || ''}
              disabled={!isCustomerManager}
            >
              <option value="">{t('SELECT_SALES_REP')}</option>
              {this.state.salespeople.map((rep) => (
                <option key={rep.email} value={rep.email}>
                  {rep.name} ({rep.email})
                </option>
              ))}
            </select>
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">
              <span>{t('COMPANY_NAME')}</span>
            </label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder={t('COMPANY_NAME')}
              onChange={this.handleChange('company_name')}
              value={shipper.company_name}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('PHONE')}</label>
            <PhoneField
              value={shipper.phone}
              disabled={!isCustomerManager}
              onChange={this.handlePhoneChange}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <CargomaticInput
              className="block mb-2 form-label"
              inputClassNames="w-full mb-4 form-field"
              type="text"
              label={t('PHONE_EXTENSION')}
              placeholder={t('PHONE_EXTENSION')}
              onChange={this.handleChange('phone_extension')}
              value={shipper.phone_extension}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('EMAIL')}</label>
            <input
              className="w-full mb-4 form-field"
              type="email"
              placeholder="example@cargomatic.com"
              onChange={this.handleChange('email')}
              value={shipper.email}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('PASSWORD')}</label>
            <input
              className="w-full mb-4 form-field"
              type="password"
              placeholder={t('PASSWORD')}
              onChange={this.handleChange('password')}
              value={shipper.password}
              disabled={!isCustomerManager}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">
              {t('MASTER_ACCOUNT')}
            </label>
            <div className="flex items-center">
              {!shipper.master_account.name && (
                <div className="w-full">
                  <CustomerSearch
                    type="master_shippers"
                    onSelect={this.handleSelect}
                    onRemove={this.handleClearMasterAccount}
                    clearOnSelect
                    disabled={!isCustomerManager}
                  />
                </div>
              )}
              {shipper.master_account.name && (
                <div className="py-2">
                  <Badge
                    color="brand"
                    withRemove
                    onRemove={this.handleClearMasterAccount}
                  >
                    {shipper.master_account.name}
                  </Badge>
                </div>
              )}
            </div>
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">
              <span>{t('SUBSIDIARY')}</span>
            </label>
            <select
              className="mb-4 form-select"
              onChange={this.handleChange('subsidiary')}
              value={shipper.subsidiary || ''}
              disabled={!isCustomerManager}
            >
              <option value="">{t('SELECT_SUBSIDIARY')}</option>
              {SHIPPER_SUBSIDIARY_OPTIONS.map((subsidiary) => (
                <option key={subsidiary.key} value={subsidiary.value}>
                  {t(subsidiary.localizationSlug)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </FormCard>
    );
  }
}

export default withTranslation()(RegisterShipper);
